/* ============================================
   FILTROUS — Product Card JavaScript
   ============================================
   Handles:
   - Quantity increment/decrement
   - Variant selection → price update
   - Variant pill buttons → price update
   - Add to Cart via AJAX (Shopify Cart API)
   ============================================ */

(function () {
  'use strict';

  // Guard against double-init (script may be included by multiple sections)
  if (window.__fnCardInit) return;
  window.__fnCardInit = true;

  // ── Quantity Buttons ──
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.fn-card__qty-btn');
    if (!btn) return;

    var wrap = btn.closest('.fn-card__qty');
    var input = wrap.querySelector('.fn-card__qty-input');
    var current = parseInt(input.value, 10) || 1;
    var action = btn.dataset.action;

    if (action === 'increase') {
      input.value = current + 1;
    } else if (action === 'decrease' && current > 1) {
      input.value = current - 1;
    }
  });


  // ── Variant Selector (dropdown) ──
  document.addEventListener('change', function (e) {
    var select = e.target.closest('.fn-card__variant-select');
    if (!select) return;

    var card = select.closest('.fn-card');
    var selectedOption = select.options[select.selectedIndex];
    var variantId = select.value;
    var price = selectedOption.dataset.price;
    var comparePrice = selectedOption.dataset.compare;

    var hiddenInput = card.querySelector('input[name="id"]');
    if (hiddenInput) {
      hiddenInput.value = variantId;
    }

    var priceEl = card.querySelector('.fn-card__price-current');
    var compareEl = card.querySelector('.fn-card__price-compare');

    if (priceEl && price) {
      priceEl.textContent = formatMoney(parseInt(price, 10));
      if (comparePrice) {
        priceEl.classList.add('fn-card__price-current--sale');
        if (compareEl) {
          compareEl.textContent = formatMoney(parseInt(comparePrice, 10));
          compareEl.style.display = '';
        }
      } else {
        priceEl.classList.remove('fn-card__price-current--sale');
        if (compareEl) {
          compareEl.style.display = 'none';
        }
      }
    }

    var atcBtn = card.querySelector('.fn-card__atc-btn');
    if (selectedOption.disabled) {
      atcBtn.disabled = false;
      atcBtn.classList.remove('fn-card__atc-btn--soldout');
      atcBtn.classList.add('fn-card__atc-btn--preorder');
      atcBtn.textContent = 'Pre-order';
    } else {
      atcBtn.disabled = false;
      atcBtn.classList.remove('fn-card__atc-btn--soldout');
      atcBtn.classList.remove('fn-card__atc-btn--preorder');
      atcBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M4 4h10.5l-1 6H5.5z"/><circle cx="6" cy="13.5" r=".75"/><circle cx="12" cy="13.5" r=".75"/><path d="M4 4L3.33 1.33H1.33"/></svg> Add to Cart';
    }
  });


  // ── Variant Pill Buttons ──
  var ATC_SVG = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M4 4h10.5l-1 6H5.5z"/><circle cx="6" cy="13.5" r=".75"/><circle cx="12" cy="13.5" r=".75"/><path d="M4 4L3.33 1.33H1.33"/></svg> Add to Cart';

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.fn-card__variant-pill');
    if (!pill) return;

    var card = pill.closest('.fn-card');
    var variantId = pill.dataset.variantId;
    var price = parseInt(pill.dataset.variantPrice, 10);
    var comparePrice = pill.dataset.variantCompare ? parseInt(pill.dataset.variantCompare, 10) : 0;
    var isAvailable = pill.dataset.variantAvailable === 'true';

    // Toggle selected state
    var allPills = card.querySelectorAll('.fn-card__variant-pill');
    allPills.forEach(function (p) { p.classList.remove('is-selected'); });
    pill.classList.add('is-selected');

    // Update hidden variant ID
    var hiddenInput = card.querySelector('input[name="id"]');
    if (hiddenInput) {
      hiddenInput.value = variantId;
    }

    // Update SKU
    var skuEl = card.querySelector('.fn-card__sku');
    var newSku = pill.dataset.variantSku;
    if (skuEl && newSku) {
      skuEl.innerHTML = 'SKU: <strong>' + newSku + '</strong>';
    }

    // Update product image (if variant has its own image)
    var variantImage = pill.dataset.variantImage;
    if (variantImage) {
      var primaryImg = card.querySelector('.fn-card__image--primary');
      if (primaryImg) {
        primaryImg.src = variantImage;
        primaryImg.srcset = variantImage.replace(/width=\d+/, 'width=300') + ' 300w, '
          + variantImage.replace(/width=\d+/, 'width=450') + ' 450w, '
          + variantImage + ' 600w';
      }
    }

    // Update displayed price
    var priceEl = card.querySelector('.fn-card__price-current');
    var compareEl = card.querySelector('.fn-card__price-compare');
    var saveEl = card.querySelector('.fn-card__price-save');
    var priceRow = card.querySelector('[data-price-row]');

    if (priceEl && price) {
      priceEl.textContent = formatMoney(price);

      if (comparePrice && comparePrice > price) {
        var savePct = Math.round((comparePrice - price) / comparePrice * 100);
        priceEl.classList.add('fn-card__price-current--sale');

        // Create compare/save elements if they don't exist (first variant had no sale)
        if (!compareEl && priceRow) {
          compareEl = document.createElement('span');
          compareEl.className = 'fn-card__price-compare';
          compareEl.setAttribute('data-compare-price', '');
          priceRow.insertBefore(compareEl, priceEl.nextSibling);
        }
        if (!saveEl && priceRow) {
          saveEl = document.createElement('span');
          saveEl.className = 'fn-card__price-save';
          saveEl.setAttribute('data-save-badge', '');
          var afterEl = compareEl ? compareEl.nextSibling : priceEl.nextSibling;
          priceRow.insertBefore(saveEl, afterEl);
        }
        if (compareEl) {
          compareEl.textContent = formatMoney(comparePrice);
          compareEl.style.display = '';
        }
        if (saveEl) {
          saveEl.textContent = 'Save ' + savePct + '%';
          saveEl.style.display = '';
        }
      } else {
        priceEl.classList.remove('fn-card__price-current--sale');
        if (compareEl) compareEl.style.display = 'none';
        if (saveEl) saveEl.style.display = 'none';
      }

      // Update unit price
      updateUnitPrice(card, price, pill.dataset.variantTitle || '');
    }

    // Update ATC button state based on variant availability
    var atcBtn = card.querySelector('.fn-card__atc-btn');
    if (atcBtn) {
      if (isAvailable) {
        atcBtn.disabled = false;
        atcBtn.classList.remove('fn-card__atc-btn--soldout');
        atcBtn.classList.remove('fn-card__atc-btn--preorder');
        atcBtn.innerHTML = ATC_SVG;
      } else {
        atcBtn.disabled = false;
        atcBtn.classList.remove('fn-card__atc-btn--soldout');
        atcBtn.classList.add('fn-card__atc-btn--preorder');
        atcBtn.textContent = 'Pre-order';
      }
    }
  });

  // ── Unit Price Helper ──
  function updateUnitPrice(card, priceCents, variantTitle) {
    var unitEl = card.querySelector('[data-unit-price]');
    var packQty = parseInt(card.dataset.packQty, 10);

    // If no pack_qty metafield, try to parse from variant title (e.g. "100/unit")
    if (!packQty || packQty <= 0) {
      if (variantTitle && variantTitle.indexOf('/') !== -1) {
        packQty = parseInt(variantTitle.split('/')[0], 10);
      }
    }

    if (packQty > 1 && priceCents > 0) {
      var each = formatMoney(Math.round(priceCents / packQty));
      if (unitEl) {
        unitEl.textContent = each + '/ea';
        unitEl.style.display = '';
      } else {
        // Create unit price element if it doesn't exist
        var priceRow = card.querySelector('[data-price-row]');
        if (priceRow) {
          unitEl = document.createElement('span');
          unitEl.className = 'fn-card__price-unit';
          unitEl.setAttribute('data-unit-price', '');
          unitEl.textContent = each + '/ea';
          priceRow.appendChild(unitEl);
        }
      }
    } else if (unitEl) {
      unitEl.style.display = 'none';
    }
  }


  // ── AJAX Add to Cart ──
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.fn-card__form');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('.fn-card__atc-btn');
    if (!btn || btn.disabled) return;

    var variantId = form.querySelector('input[name="id"]').value;
    var quantity = parseInt(form.querySelector('.fn-card__qty-input')?.value, 10) || 1;

    // Loading state
    var originalHTML = btn.innerHTML;
    btn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:6px;"><svg width="14" height="14" viewBox="0 0 14 14" style="animation:fn-spin 0.6s linear infinite"><circle cx="7" cy="7" r="5.5" stroke="currentColor" stroke-width="1.5" fill="none" stroke-dasharray="24" stroke-dashoffset="8" stroke-linecap="round"/></svg> Adding...</span>';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: quantity
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function () {
        btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M11.5 3.5L5.5 9.5L2.5 6.5"/></svg> Added!';
        btn.style.background = '#061A27';
        btn.style.color = '#7DF9FF';

        updateCartCount();

        setTimeout(function () {
          btn.innerHTML = originalHTML;
          btn.disabled = false;
          btn.style.background = '';
          btn.style.color = '';
        }, 2000);
      })
      .catch(function () {
        btn.innerHTML = 'Error — Try Again';
        btn.disabled = false;
        setTimeout(function () {
          btn.innerHTML = originalHTML;
        }, 2000);
      });
  });


  // ── Update Cart Count (nav badge) ──
  function updateCartCount() {
    fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badges = document.querySelectorAll('.fn-nav__cart-count');
        badges.forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(function () { /* silent */ });
  }


  // ── Format Money ──
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

})();

/* Spin animation for loading state */
if (!document.getElementById('fn-card-keyframes')) {
  var style = document.createElement('style');
  style.id = 'fn-card-keyframes';
  style.textContent = '@keyframes fn-spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(style);
}
